import React from 'react';
import { AlertTriangle, XCircle, Package } from 'lucide-react';

function LowStockAlerts({ data }) {
  if (!data) {
    return null;
  }

  const { low_stock = [], out_of_stock = [] } = data;

  if (low_stock.length === 0 && out_of_stock.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-slate-200 p-8 text-center">
        <Package className="w-12 h-12 text-slate-300 mx-auto mb-3" />
        <p className="text-slate-500 font-montserrat">No hay alertas de stock</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Low Stock */}
      {low_stock.length > 0 && (
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <div className="bg-amber-50 border-b border-amber-200 px-4 py-3">
            <h3 className="text-sm font-bold text-amber-900 font-montserrat flex items-center gap-2">
              <AlertTriangle className="w-4 h-4" />
              Stock Bajo ({low_stock.length})
            </h3>
          </div>
          <div className="max-h-80 overflow-y-auto">
            <table className="w-full">
              <thead className="bg-slate-50 sticky top-0">
                <tr>
                  <th className="px-4 py-2 text-left text-xs font-semibold text-slate-600 font-montserrat">
                    Producto
                  </th>
                  <th className="px-4 py-2 text-right text-xs font-semibold text-slate-600 font-montserrat">
                    Stock
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {low_stock.map((item, index) => (
                  <tr key={index} className="hover:bg-slate-50 transition-colors">
                    <td className="px-4 py-3">
                      <div>
                        <p className="text-sm font-semibold text-slate-900 font-montserrat">
                          {item.title}
                        </p>
                        <p className="text-xs text-slate-500 font-montserrat">
                          {item.sku} • {item.location}
                        </p>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-right">
                      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-bold font-montserrat ${
                        item.status === 'critical'
                          ? 'bg-red-50 text-red-600'
                          : 'bg-amber-50 text-amber-600'
                      }`}>
                        {item.quantity} uds
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Out of Stock */}
      {out_of_stock.length > 0 && (
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <div className="bg-red-50 border-b border-red-200 px-4 py-3">
            <h3 className="text-sm font-bold text-red-900 font-montserrat flex items-center gap-2">
              <XCircle className="w-4 h-4" />
              Sin Stock ({out_of_stock.length})
            </h3>
          </div>
          <div className="max-h-80 overflow-y-auto">
            <table className="w-full">
              <thead className="bg-slate-50 sticky top-0">
                <tr>
                  <th className="px-4 py-2 text-left text-xs font-semibold text-slate-600 font-montserrat">
                    Producto
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-semibold text-slate-600 font-montserrat">
                    Ubicación
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {out_of_stock.map((item, index) => (
                  <tr key={index} className="hover:bg-slate-50 transition-colors">
                    <td className="px-4 py-3">
                      <div>
                        <p className="text-sm font-semibold text-slate-900 font-montserrat">
                          {item.title}
                        </p>
                        <p className="text-xs text-slate-500 font-montserrat">{item.sku}</p>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <p className="text-sm text-slate-600 font-montserrat">{item.location}</p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default LowStockAlerts;